/**
 * The social.js uses the social texts specified in the config
 * and inserts them as links into the social buttons in the header
 */

const config = ARTICLE_CONFIG;

const url = encodeURIComponent(config.meta.ogUrl);

function init() {
  whatsapp();
  facebook();
  twitter();
}

function whatsapp() {
  const href = 'whatsapp://send?text=' + config.social.whatsapp.replace('{{url}}', url);
  const waBtns = document.querySelectorAll('.wa-btn');

  [].forEach.call(waBtns, e => e.setAttribute('href', href));
}

function facebook() {
  const fbButtons = document.querySelectorAll('.btn-facebook');
  [].forEach.call(fbButtons, e => e.setAttribute('href', getFbLink()));
}

function twitter() {
  const fbButtons = document.querySelectorAll('.btn-twitter');
  [].forEach.call(fbButtons, e => e.setAttribute('href', getTwitterLink()));
}

function getFbLink() {
  return `https://www.facebook.com/sharer/sharer.php?u=${url}&t=${encodeURIComponent(config.social.facebook).replace('%7B%7Burl%7D%7D', url)}`;
}

function getTwitterLink() {
  return `https://twitter.com/intent/tweet?source=${url}&text=${encodeURIComponent(config.social.twitter).replace('%7B%7Burl%7D%7D', url)}`;
}

export default {
  init,
  getFbLink,
  getTwitterLink
};
